import React from 'react'
import {connect} from 'react-redux'
import { push } from 'react-router-redux'

import Header from './Header'
import * as dashboardActions from '../../actions/dashboardActions'
import * as authActions from '../../actions/authActions'
import * as uiActions from '../../actions/uiActions'
import {Flex, Box} from 'reflexbox'
import Snackbar from 'material-ui/Snackbar'
import CircularProgress from 'material-ui/CircularProgress'

const styles = {
  loading: {
    top: '2em',
    left: '50%',
    marginLeft: '-20px'
  },
  container: {
    minHeight: '100vh'
  }
}

const Loading = (props) => {
  return (
    <CircularProgress
      size={40}
      style={styles.loading} />
  )
}

const MasterPage = (props) => {
  if (!props.isLoadStarted)
  {
    props.load()
    props.mqttConnect(undefined, undefined, ['i/mvp', 'i/mvp/+', 'i/mvp/+/+'])
  }

  return (
    <Flex align="center" flexColumn={true} style={styles.container}>
      <Box col={12}>
        <Header
          isStaff={props.isStaff}
          connected={props.hubs.every(hub => hub.status === true)}
          condominium={props.condominium}
          handleLogout={props.logout} />
      </Box>
      <Box flexAuto={true} col={12} lg={10}>
        {(props.isLoading > 0 || !props.isLoadStarted) ? <Loading /> : props.children}
        <Snackbar {...props.snackbar} onRequestClose={props.hideSnackbar} />
      </Box>
      <Box col={12}>
        {/* Rodapé */}
      </Box>
    </Flex>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    isStaff: state.auth.isStaff,
    isLoadStarted: state.dashboard.isLoadStarted,
    isLoading: state.dashboard.isLoading,
    snackbar: state.ui.snackbar,
    condominium: state.condominium,
    hubs: state.hubs
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    mqttConnect: (username, password, topics) => dispatch(dashboardActions.mqttConnect(username, password, topics)),
    load: (id) => dispatch(dashboardActions.load()),
    hideSnackbar: () => dispatch(uiActions.hideSnackbar()),
    logout: () => dispatch(authActions.logout()),
    navigate: (path) => {
      dispatch(push(path))
      dispatch(uiActions.closeDrawer())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterPage)



/** WEBPACK FOOTER **
 ** ./src/components/layout/Layout.js
 **/